import { companyInfo } from '../data/mock';
import ContactInfo from './Contact/ContactInfo';

const Contact = () => (
  <section id="contact" className="contact-section">
    <div className="container">
      <div className="contact-content">
        <div className="contact-info">
          <h2 className="contact-title">Pour des Fenêtres Impeccables</h2>
          <p className="contact-subtitle">
            Contactez-nous dès aujourd'hui pour obtenir votre soumission gratuite et sans engagement.
          </p>
          <ContactInfo />
        </div>
        <div className="contact-image">
          <img 
            src={companyInfo.heroImage} 
            alt="Service Bois-Franc"
            className="contact-img"
          />
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
